import { isSubscription } from 'components/cart/utils/typeInference';
import type { Subscription } from 'types/product/Subscription';
import type { Variant } from 'types/product/Variant';
import type { VariantOrSubscription } from 'types/product/VariantOrSubscription';

export const findMatchingVariantOrSub = (
  variants: Variant[],
  subscriptions: Subscription[],
  selectedVariantOrSub?: VariantOrSubscription,
) => {
  if (!selectedVariantOrSub) {
    return undefined;
  }

  if (isSubscription(selectedVariantOrSub)) {
    const selectedSubscription = selectedVariantOrSub as Subscription;
    const subscriptionTitle = selectedSubscription.sellingPlan.title;

    return subscriptions.find(
      (item) => item.sellingPlan.title === subscriptionTitle,
    );
  }

  const variantTitle = selectedVariantOrSub.title;

  if (variantTitle) {
    return variants.find((item) => item.title === variantTitle);
  }

  return undefined;
};
